import React from 'react'
import { SvgIcon } from '@mui/material'

export function MutedMicIcon({ className }: { className?: string }) {
  return (
    <SvgIcon
      viewBox="0 0 34 34"
      sx={{ color: 'gray', width: '34px', height: '34px' }}
      className={className}
    >
      <path
        d="M15.13 6.66a2.5 2.5 0 0 1 3.68-.17c.45.47.7 1.1.69 1.76v4.26a1.25 1.25 0 0 0 2.5 0V8.25a5 5 0 0 0-8.75-3.16 1.25 1.25 0 1 0 1.88 1.57ZM25.4 18.6h.25a1.25 1.25 0 0 0 1.25-1.01c.09-.6.12-1.22.1-1.83a1.25 1.25 0 0 0-2.5 0c0 .46-.05.92-.14 1.38a1.25 1.25 0 0 0 1.04 1.46Zm3.75 7.57L6.65 3.66a1.25 1.25 0 1 0-1.77 1.77L12 12.6v3.15a5 5 0 0 0 7.5 4.33l1.82 1.82A7.5 7.5 0 0 1 9.5 15.75a1.25 1.25 0 0 0-2.5 0 10 10 0 0 0 8.75 9.91v2.59h-2.5a1.25 1.25 0 0 0 0 2.5h7.5a1.25 1.25 0 0 0 0-2.5h-2.5v-2.59a9.84 9.84 0 0 0 4.81-1.98l4.25 4.25a1.25 1.25 0 1 0 1.78-1.77h.06ZM17 18.25a2.5 2.5 0 0 1-2.5-2.5v-.65l3.06 3.08c-.18.04-.37.07-.56.07Z"
        fill="inherit"
      />
    </SvgIcon>
  )
}

MutedMicIcon.defaultProps = {
  className: '',
}
